import { render } from "./Modals.vue?vue&type=template&id=6fa19803"
import script from "./Modals.vue?vue&type=script&lang=js"
export * from "./Modals.vue?vue&type=script&lang=js"
script.render = render

export default script